import { cn } from "@/lib/utils";

export function CloseIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-2 text-white", className)}
      viewBox="0 0 8 8"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M6.474.47a.75.75 0 011.06 1.06l-2.47 2.472 2.471 2.471a.75.75 0 11-1.06 1.061L4.001 5.063l-2.47 2.471a.75.75 0 11-1.06-1.06l2.47-2.472L.47 1.53A.75.75 0 011.53.47l2.472 2.47L6.474.47z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}

export function LeftArrowIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3.5 text-white", className)}
      fill="none"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.237 2.625L.875 7m0 0l4.362 4.375M.875 7h12.25"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export function LeftChevronIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-3.5 w-2 text-rose-red", className)}
      fill="none"
      viewBox="0 0 8 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 13L1 7l6-6"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}
